/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Compose_Placeholder_HintInputs */

const en_mail_compose_placeholder_hint = /** @type {(inputs: Mail_Compose_Placeholder_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Double-click to insert)`)
};

const de_mail_compose_placeholder_hint = /** @type {(inputs: Mail_Compose_Placeholder_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Doppelklick fügt ein)`)
};

/**
* | output |
* | --- |
* | "(Double-click to insert)" |
*
* @param {Mail_Compose_Placeholder_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_placeholder_hint = /** @type {((inputs?: Mail_Compose_Placeholder_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_Placeholder_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_placeholder_hint(inputs)
	return en_mail_compose_placeholder_hint(inputs)
});